















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-cloud-upload',

})
export default class ICloudUpload extends Vue {
  @Prop({type: [String], default: '#8EC6E7'}) protected color!: string

}

